import { defaultClient } from '@mint-sdk/api-core';

import { UserDetailsResponseSchema } from '../shared/schemas/UserDetailsSchema.js';

export const getUserDetails = defaultClient.query({
  url: 'authentication/v1/users/summary/?ids=$userIds' as const,
  method: 'GET',
  responseSchema: UserDetailsResponseSchema,
  processResponse(data) {
    return data;
  },
});
